import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractTranslatedApiErrorMessage } from '../../shared/utils/translate-api-error.util';
import { Category } from '../types/category.type';
import { UpdateCategoryRequestDTO } from '../types/dtos/update-category.dto';
import { ADMIN_CATEGORIES_API_PATHS } from '../constants/categories-api-paths.constants';

type UpdateCategoryParams = {
  categoryId: string;
  categoryData: UpdateCategoryRequestDTO;
};

type UseUpdateCategoryResult = {
  updateCategory: (params: UpdateCategoryParams) => Promise<Category | null>;
  isSubmitting: boolean;
};

export function useUpdateCategory(): UseUpdateCategoryResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const updateCategory = async ({ categoryId, categoryData }: UpdateCategoryParams): Promise<Category | null> => {
    setIsSubmitting(true);

    try {
      const updatedCategory = await HttpClient.patch<Category, UpdateCategoryRequestDTO>(
        ADMIN_CATEGORIES_API_PATHS.UPDATE_CATEGORY(categoryId),
        categoryData
      );

      enqueueSnackbar('La rubrique a été mise à jour', { variant: 'success' });
      return updatedCategory;
    } catch (error) {
      enqueueSnackbar(
        extractTranslatedApiErrorMessage(error, 'Une erreur est survenue lors de la mise à jour de la rubrique'),
        { variant: 'error' }
      );
      return null;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { updateCategory, isSubmitting };
}
